import {
  ADDRESS_DESCRIPTIONS,
  ADDRESS_LABELS,
  ADDRESS_SUB_TYPE_VALUES,
  SUPPORTED_INPUT_TYPES,
} from "../../../util/constants";
import Fieldset from "./Fieldset";
import { Mui } from "@osu/react-ui";
import Switch from "../Switch";
import { useState } from "react";

const fieldSetStyles = (theme) => {
  return {
    "& > *:not(:last-child)": {
      marginBottom: theme.spacing(1),
    },
  };
};

const inlineGroupStyles = (theme) => ({
  "& > *": {
    flex: 1,
    marginBottom: theme.spacing()
  },
  "& > *:not(:last-child)": {
    marginRight: "1rem",
  },
  width: "100%",
});
const defaultRegionLabel = "State / Province / Region"

const subFields = Object.values(ADDRESS_SUB_TYPE_VALUES)
function Address(props = {}) {
  const {
    id,
    label,
    description,
    required,
    variant,
    name,
    value,
    readOnly,
    showErrorForMissingField,
  } = props;
  let primary, secondary;
  const [regionLabel, setRegionLabel] = useState(defaultRegionLabel)
  if (label && description) {
    primary = label;
    secondary = description;
  } else if (label && !description) {
    primary = label;
  } else if (!label && description) {
    primary = description;
  }

  if (!primary) {
    primary = "Address";
  }

  let singleRow = [];
  let inline = [];

  const requiredFields = [
    ADDRESS_SUB_TYPE_VALUES.line1,
    ADDRESS_SUB_TYPE_VALUES.country,
    ADDRESS_SUB_TYPE_VALUES.zip,
    ADDRESS_SUB_TYPE_VALUES.city,
    ADDRESS_SUB_TYPE_VALUES.state,
  ];


  subFields.forEach((subField, idx) => {
    const lastItem = idx === subFields.length - 1;
    const isCountry = subField === ADDRESS_SUB_TYPE_VALUES.country;
    let defaultValue = value?.[subField] || undefined
    const isRequired = (required && requiredFields.includes(subField));
    const formatted = {
      name: `${name}.${subField}`,
      label: ADDRESS_LABELS?.[subField],
      helperText: ADDRESS_DESCRIPTIONS?.[subField],
      id: id + "#" + subField,
      required: isRequired,
      dataType: isCountry 
        ? SUPPORTED_INPUT_TYPES.country 
        : SUPPORTED_INPUT_TYPES.textInput,
      className: !lastItem ? "margin-bottom-2" : undefined,
      defaultValue,
      readOnly
    };

    if(isCountry) {
      formatted.onChange = (event, value) => {
        if(value?.regionType) {
          setRegionLabel(value.regionType)
        } else {
          setRegionLabel(defaultRegionLabel)
        }
      }
    }
    if(subField === ADDRESS_SUB_TYPE_VALUES.city) {
      formatted.transformOnBlur = (val) => val.replace(/\b\w/g, c => c.toUpperCase())
    }
    if(subField === ADDRESS_SUB_TYPE_VALUES.state) {
      formatted.transformOnBlur = (val) => val.toUpperCase()
    }
    if(subField === ADDRESS_SUB_TYPE_VALUES.state && regionLabel) {
      formatted.label = regionLabel
    }
    const valid = formatted.name && formatted.label && subField;
    if (!valid) {
      return;
    }
    if (
      [ADDRESS_SUB_TYPE_VALUES.country, ADDRESS_SUB_TYPE_VALUES.line1, ADDRESS_SUB_TYPE_VALUES.line2].includes(
        subField
      )
    ) {
      singleRow.push(formatted);
    } else if(subField === ADDRESS_SUB_TYPE_VALUES.city) {
      inline.push(formatted);
    } else {
      inline.push(formatted);
    }
  });

  if (!singleRow?.length && !inline?.length) {
    return false;
  }

  return (
    <Fieldset legend={primary} description={secondary} sx={fieldSetStyles}>
      {singleRow.map(({ label, name, id: subId, ...rest }, idx) => {
        return (
          <Switch
            key={idx + subId}
            id={subId}
            label={label}
            name={name}
            variant={variant}
            showErrorForMissingField={showErrorForMissingField}
            {...rest}
          />
        );
      })}
      {inline.length && (
        <Mui.FormGroup row sx={inlineGroupStyles}>
          {inline.map(({ label, name, id: subId, ...rest }, idx) => {
            return (
              <Switch
                key={idx + subId}
                id={subId}
                label={label}
                name={name}
                variant={variant}
                showErrorForMissingField={showErrorForMissingField}
                {...rest}
              />
            );
          })}
        </Mui.FormGroup>
      )}
    </Fieldset>
  );
}

export default Address;
